// Room Assets:
import roomSound from './sounds/roomSound.mp3'
import bg from './bg.jpg'

export const ROOM_0 = {
  roomSound,
  roomImg: bg,
  bgSound: null,
  roomContent: null,
}
